import React from 'react';
import { Button } from '@mui/material';
import { track, events } from 'src/configs/amplitude';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'src/stores';
import useStyles from './styles';
export default function LogoutButton() {
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const navigate = useNavigate();
  const classes = useStyles();
  const logout = async () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    await store.account.logoutAccountAsync.run();
    track(events.loggedOut());
    store.auth.reset();
    store.payment.resetPaymentMethods();
    navigate('/login');
  };
  return /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: logout,
    className: classes.logOutButton,
    size: "small",
    'custom-attribute': '337-LogoutButton'
  }, t('app_menus.log_out'));
}